import './App.css';

import DatePicker from './Components/DatePicker/DatePicker';

function App() {
  return (
    <div className="App">
      <DatePicker />
    </div>
  );
}

export default App;
